import moment from "moment";
import { api } from "../App";
import { createNotification } from "../components/Notifications/Notifications";

import {
  SET_SCHEDULE_CURRENT_LOADING,
  GET_SCHEDULE_CURRENT,
  GET_SCHEDULE_CLASS_LIST,
  GET_SCHEDULE_WEEKS_LIST,
  GET_SCHEDULE_CURRENT_NEW,
  SET_SCHEDULE_CURRENT_NEW_LOADING
} from "./types";

export const getCurrentSchedule = (params) => async (dispatch, getState) => {
  dispatch({ type: SET_SCHEDULE_CURRENT_LOADING, payload: true });
  try {
    const { data } = await api.get(`/schedule/${params.week}/${params.teacher || '0'}`);
    dispatch({ type: GET_SCHEDULE_CURRENT, payload: data?.schedule || [] });
  } catch (error) {
    dispatch({ type: GET_SCHEDULE_CURRENT, payload: [] });
  } finally {
    dispatch({ type: SET_SCHEDULE_CURRENT_LOADING, payload: false });
  }
}

export const getCurrentScheduleNew = (params) => async (dispatch) => {
  dispatch({ type: SET_SCHEDULE_CURRENT_NEW_LOADING, payload: true });
  try {
    const { data } = await api.get(`/room_day_schedule/${params.room}${params.date != moment().format('YYYY-MM-DD') ? `?date=${params.date}` : ''}`);
    if (data.find(el => el.name1 != null)) {
      dispatch({ type: GET_SCHEDULE_CURRENT_NEW, payload: data });
    } else {
      dispatch({ type: GET_SCHEDULE_CURRENT_NEW, payload: [] });
    }
  } catch (error) {
    dispatch({ type: GET_SCHEDULE_CURRENT_NEW, payload: [] });
  } finally {
    dispatch({ type: SET_SCHEDULE_CURRENT_NEW_LOADING, payload: false });
  }
}

export const getScheduleWeek = (xp_key_year) => async (dispatch) => {
  dispatch({ type: SET_SCHEDULE_CURRENT_LOADING, payload: true });
  try {
    const { data } = await api.get(`/library/weeks?school_year=${xp_key_year}`);
    dispatch({ type: GET_SCHEDULE_WEEKS_LIST, payload: data.data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_SCHEDULE_CURRENT_LOADING, payload: false });
  }
}

export const getScClassSchedule = (params) => async (dispatch) => {
  dispatch({ type: SET_SCHEDULE_CURRENT_LOADING, payload: true });
  try {
    const { data } = await api.get(`/schedule/year/${params.week}`);
    dispatch({ type: GET_SCHEDULE_CLASS_LIST, payload: data.years });
  } catch (error) {
  } finally {
    dispatch({ type: SET_SCHEDULE_CURRENT_LOADING, payload: false });
  }
}

